__turbopack_context__.v({
  "contactOpen": "Header-module-scss-module__t7BEda__contactOpen",
  "contactWrap": "Header-module-scss-module__t7BEda__contactWrap",
  "ctaMeta": "Header-module-scss-module__t7BEda__ctaMeta",
  "dot": "Header-module-scss-module__t7BEda__dot",
  "header": "Header-module-scss-module__t7BEda__header",
  "isActive": "Header-module-scss-module__t7BEda__isActive",
  "isScrolled": "Header-module-scss-module__t7BEda__isScrolled",
  "link": "Header-module-scss-module__t7BEda__link",
  "links": "Header-module-scss-module__t7BEda__links",
  "panel": "Header-module-scss-module__t7BEda__panel",
  "panelCta": "Header-module-scss-module__t7BEda__panelCta",
  "panelHead": "Header-module-scss-module__t7BEda__panelHead",
  "panelItem": "Header-module-scss-module__t7BEda__panelItem",
  "panelMeta": "Header-module-scss-module__t7BEda__panelMeta",
  "panelOpen": "Header-module-scss-module__t7BEda__panelOpen",
  "panelRowIn": "Header-module-scss-module__t7BEda__panelRowIn",
  "role": "Header-module-scss-module__t7BEda__role",
  "wordmark": "Header-module-scss-module__t7BEda__wordmark",
  "wordmarkHome": "Header-module-scss-module__t7BEda__wordmarkHome",
  "wordmarkName": "Header-module-scss-module__t7BEda__wordmarkName",
});
